// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global Styles */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* Mobile touch optimizations */
button, a, input, select, textarea {
  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;
}

/* Improve touch targets on mobile */
@media (max-width: 768px) {
  button, a, input, select, textarea {
    min-height: 44px;
    min-width: 44px;
  }
}

html {
  scroll-behavior: smooth;
  /* Mobile viewport optimization */
  -webkit-text-size-adjust: 100%;
  -ms-text-size-adjust: 100%;
}

body {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  line-height: 1.6;
  color: var(--text-primary);
  background-color: var(--bg-primary);
  /* Mobile optimizations */
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;
  transition: background-color 0.3s ease, color 0.3s ease;
}

.App {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.main-content {
  flex: 1;
  padding-top: 70px; /* Account for fixed header */
}

/* Typography */
h1, h2, h3, h4, h5, h6 {
  font-family: 'Inter', sans-serif;
  font-weight: 600;
  line-height: 1.3;
  color: var(--text-primary);
}

h1 {
  font-size: 2.5rem;
  font-weight: 700;
}

h2 {
  font-size: 2rem;
  font-weight: 600;
}

h3 {
  font-size: 1.5rem;
  font-weight: 600;
}

p {
  margin-bottom: 1rem;
  color: var(--text-secondary);
}

a {
  color: var(--accent-primary);
  text-decoration: none;
  transition: color 0.3s ease;
}

a:hover {
  color: var(--accent-hover);
}

/* Buttons */
button {
  font-family: inherit;
  cursor: pointer;
  border: none;
  outline: none;
  transition: all 0.3s ease;
}

button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Form Elements */
input, textarea, select {
  font-family: inherit;
  border: 1px solid var(--border-primary);
  border-radius: 8px;
  padding: 0.75rem 1rem;
  font-size: 1rem;
  background: var(--bg-primary);
  color: var(--text-primary);
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
}

input:focus, textarea:focus, select:focus {
  outline: none;
  border-color: var(--accent-primary);
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
}

/* Utility Classes */
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

.text-center {
  text-align: center;
}

.text-left {
  text-align: left;
}

.text-right {
  text-align: right;
}

.mb-1 { margin-bottom: 0.25rem; }
.mb-2 { margin-bottom: 0.5rem; }
.mb-3 { margin-bottom: 0.75rem; }
.mb-4 { margin-bottom: 1rem; }
.mb-5 { margin-bottom: 1.25rem; }
.mb-6 { margin-bottom: 1.5rem; }

.mt-1 { margin-top: 0.25rem; }
.mt-2 { margin-top: 0.5rem; }
.mt-3 { margin-top: 0.75rem; }
.mt-4 { margin-top: 1rem; }
.mt-5 { margin-top: 1.25rem; }
.mt-6 { margin-top: 1.5rem; }

.p-1 { padding: 0.25rem; }
.p-2 { padding: 0.5rem; }
.p-3 { padding: 0.75rem; }
.p-4 { padding: 1rem; }
.p-5 { padding: 1.25rem; }
.p-6 { padding: 1.5rem; }

/* Responsive Design */
@media (max-width: 768px) {
  .container {
    padding: 0 1rem;
  }
  
  h1 {
    font-size: 2rem;
  }
  
  h2 {
    font-size: 1.75rem;
  }
  
  h3 {
    font-size: 1.25rem;
  }
}

/* Loading and Error States */
.loading-container,
.error-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 50vh;
  gap: 1rem;
  text-align: center;
  padding: 2rem;
}

.loading-spinner {
  width: 50px;
  height: 50px;
  border: 4px solid var(--border-primary);
  border-top: 4px solid var(--accent-primary);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.error-container h2 {
  color: var(--error);
  margin: 0;
}

.error-container p {
  color: var(--text-secondary);
  margin: 0;
}

/* Accessibility */
@media (prefers-reduced-motion: reduce) {
  * {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
  }
  
  html {
    scroll-behavior: auto;
  }
}

/* Focus styles for keyboard navigation */
button:focus-visible,
a:focus-visible,
input:focus-visible,
textarea:focus-visible,
select:focus-visible {
  outline: 2px solid var(--accent-primary);
  outline-offset: 2px;
}

/* Print styles */
@media print {
  .header,
  .footer,
  .purchase-btn,
  .menu-toggle {
    display: none !important;
  }
  
  .main-content {
    padding-top: 0;
  }
  
  body {
    background: white;
    color: black;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA,+BAA+B;AAC/B;EACE,wCAAwC;EACxC,0BAA0B;AAC5B;;AAEA,oCAAoC;AACpC;EACE;IACE,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA;EACE,uBAAuB;EACvB,iCAAiC;EACjC,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,gBAAgB;EAChB,0BAA0B;EAC1B,mCAAmC;EACnC,yBAAyB;EACzB,8BAA8B;EAC9B,wCAAwC;EACxC,0BAA0B;EAC1B,uDAAuD;AACzD;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,OAAO;EACP,iBAAiB,EAAE,6BAA6B;AAClD;;AAEA,eAAe;AACf;EACE,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,YAAY;AACZ;EACE,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,oBAAoB;EACpB,uCAAuC;EACvC,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,6BAA6B;EAC7B,0BAA0B;EAC1B,wDAAwD;AAC1D;;AAEA;EACE,aAAa;EACb,mCAAmC;EACnC,4CAA4C;AAC9C;;AAEA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,QAAQ,sBAAsB,EAAE;AAChC,QAAQ,qBAAqB,EAAE;AAC/B,QAAQ,sBAAsB,EAAE;AAChC,QAAQ,mBAAmB,EAAE;AAC7B,QAAQ,sBAAsB,EAAE;AAChC,QAAQ,qBAAqB,EAAE;;AAE/B,QAAQ,mBAAmB,EAAE;AAC7B,QAAQ,kBAAkB,EAAE;AAC5B,QAAQ,mBAAmB,EAAE;AAC7B,QAAQ,gBAAgB,EAAE;AAC1B,QAAQ,mBAAmB,EAAE;AAC7B,QAAQ,kBAAkB,EAAE;;AAE5B,OAAO,gBAAgB,EAAE;AACzB,OAAO,eAAe,EAAE;AACxB,OAAO,gBAAgB,EAAE;AACzB,OAAO,aAAa,EAAE;AACtB,OAAO,gBAAgB,EAAE;AACzB,OAAO,eAAe,EAAE;;AAExB,sBAAsB;AACtB;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,6BAA6B;AAC7B;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,2CAA2C;EAC3C,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,4BAA4B;EAC5B,SAAS;AACX;;AAEA,kBAAkB;AAClB;EACE;IACE,qCAAqC;IACrC,uCAAuC;IACvC,sCAAsC;EACxC;;EAEA;IACE,qBAAqB;EACvB;AACF;;AAEA,yCAAyC;AACzC;;;;;EAKE,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE;;;;IAIE,wBAAwB;EAC1B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,YAAY;EACd;AACF","sourcesContent":["/* Global Styles */\r\n* {\r\n  margin: 0;\r\n  padding: 0;\r\n  box-sizing: border-box;\r\n}\r\n\r\n/* Mobile touch optimizations */\r\nbutton, a, input, select, textarea {\r\n  -webkit-tap-highlight-color: transparent;\r\n  touch-action: manipulation;\r\n}\r\n\r\n/* Improve touch targets on mobile */\r\n@media (max-width: 768px) {\r\n  button, a, input, select, textarea {\r\n    min-height: 44px;\r\n    min-width: 44px;\r\n  }\r\n}\r\n\r\nhtml {\r\n  scroll-behavior: smooth;\r\n  /* Mobile viewport optimization */\r\n  -webkit-text-size-adjust: 100%;\r\n  -ms-text-size-adjust: 100%;\r\n}\r\n\r\nbody {\r\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\r\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\r\n    sans-serif;\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n  line-height: 1.6;\r\n  color: var(--text-primary);\r\n  background-color: var(--bg-primary);\r\n  /* Mobile optimizations */\r\n  -webkit-text-size-adjust: 100%;\r\n  -webkit-tap-highlight-color: transparent;\r\n  touch-action: manipulation;\r\n  transition: background-color 0.3s ease, color 0.3s ease;\r\n}\r\n\r\n.App {\r\n  min-height: 100vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.main-content {\r\n  flex: 1;\r\n  padding-top: 70px; /* Account for fixed header */\r\n}\r\n\r\n/* Typography */\r\nh1, h2, h3, h4, h5, h6 {\r\n  font-family: 'Inter', sans-serif;\r\n  font-weight: 600;\r\n  line-height: 1.3;\r\n  color: var(--text-primary);\r\n}\r\n\r\nh1 {\r\n  font-size: 2.5rem;\r\n  font-weight: 700;\r\n}\r\n\r\nh2 {\r\n  font-size: 2rem;\r\n  font-weight: 600;\r\n}\r\n\r\nh3 {\r\n  font-size: 1.5rem;\r\n  font-weight: 600;\r\n}\r\n\r\np {\r\n  margin-bottom: 1rem;\r\n  color: var(--text-secondary);\r\n}\r\n\r\na {\r\n  color: var(--accent-primary);\r\n  text-decoration: none;\r\n  transition: color 0.3s ease;\r\n}\r\n\r\na:hover {\r\n  color: var(--accent-hover);\r\n}\r\n\r\n/* Buttons */\r\nbutton {\r\n  font-family: inherit;\r\n  cursor: pointer;\r\n  border: none;\r\n  outline: none;\r\n  transition: all 0.3s ease;\r\n}\r\n\r\nbutton:disabled {\r\n  opacity: 0.6;\r\n  cursor: not-allowed;\r\n}\r\n\r\n/* Form Elements */\r\ninput, textarea, select {\r\n  font-family: inherit;\r\n  border: 1px solid var(--border-primary);\r\n  border-radius: 8px;\r\n  padding: 0.75rem 1rem;\r\n  font-size: 1rem;\r\n  background: var(--bg-primary);\r\n  color: var(--text-primary);\r\n  transition: border-color 0.3s ease, box-shadow 0.3s ease;\r\n}\r\n\r\ninput:focus, textarea:focus, select:focus {\r\n  outline: none;\r\n  border-color: var(--accent-primary);\r\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);\r\n}\r\n\r\n/* Utility Classes */\r\n.container {\r\n  max-width: 1200px;\r\n  margin: 0 auto;\r\n  padding: 0 2rem;\r\n}\r\n\r\n.text-center {\r\n  text-align: center;\r\n}\r\n\r\n.text-left {\r\n  text-align: left;\r\n}\r\n\r\n.text-right {\r\n  text-align: right;\r\n}\r\n\r\n.mb-1 { margin-bottom: 0.25rem; }\r\n.mb-2 { margin-bottom: 0.5rem; }\r\n.mb-3 { margin-bottom: 0.75rem; }\r\n.mb-4 { margin-bottom: 1rem; }\r\n.mb-5 { margin-bottom: 1.25rem; }\r\n.mb-6 { margin-bottom: 1.5rem; }\r\n\r\n.mt-1 { margin-top: 0.25rem; }\r\n.mt-2 { margin-top: 0.5rem; }\r\n.mt-3 { margin-top: 0.75rem; }\r\n.mt-4 { margin-top: 1rem; }\r\n.mt-5 { margin-top: 1.25rem; }\r\n.mt-6 { margin-top: 1.5rem; }\r\n\r\n.p-1 { padding: 0.25rem; }\r\n.p-2 { padding: 0.5rem; }\r\n.p-3 { padding: 0.75rem; }\r\n.p-4 { padding: 1rem; }\r\n.p-5 { padding: 1.25rem; }\r\n.p-6 { padding: 1.5rem; }\r\n\r\n/* Responsive Design */\r\n@media (max-width: 768px) {\r\n  .container {\r\n    padding: 0 1rem;\r\n  }\r\n  \r\n  h1 {\r\n    font-size: 2rem;\r\n  }\r\n  \r\n  h2 {\r\n    font-size: 1.75rem;\r\n  }\r\n  \r\n  h3 {\r\n    font-size: 1.25rem;\r\n  }\r\n}\r\n\r\n/* Loading and Error States */\r\n.loading-container,\r\n.error-container {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  min-height: 50vh;\r\n  gap: 1rem;\r\n  text-align: center;\r\n  padding: 2rem;\r\n}\r\n\r\n.loading-spinner {\r\n  width: 50px;\r\n  height: 50px;\r\n  border: 4px solid var(--border-primary);\r\n  border-top: 4px solid var(--accent-primary);\r\n  border-radius: 50%;\r\n  animation: spin 1s linear infinite;\r\n}\r\n\r\n@keyframes spin {\r\n  0% { transform: rotate(0deg); }\r\n  100% { transform: rotate(360deg); }\r\n}\r\n\r\n.error-container h2 {\r\n  color: var(--error);\r\n  margin: 0;\r\n}\r\n\r\n.error-container p {\r\n  color: var(--text-secondary);\r\n  margin: 0;\r\n}\r\n\r\n/* Accessibility */\r\n@media (prefers-reduced-motion: reduce) {\r\n  * {\r\n    animation-duration: 0.01ms !important;\r\n    animation-iteration-count: 1 !important;\r\n    transition-duration: 0.01ms !important;\r\n  }\r\n  \r\n  html {\r\n    scroll-behavior: auto;\r\n  }\r\n}\r\n\r\n/* Focus styles for keyboard navigation */\r\nbutton:focus-visible,\r\na:focus-visible,\r\ninput:focus-visible,\r\ntextarea:focus-visible,\r\nselect:focus-visible {\r\n  outline: 2px solid var(--accent-primary);\r\n  outline-offset: 2px;\r\n}\r\n\r\n/* Print styles */\r\n@media print {\r\n  .header,\r\n  .footer,\r\n  .purchase-btn,\r\n  .menu-toggle {\r\n    display: none !important;\r\n  }\r\n  \r\n  .main-content {\r\n    padding-top: 0;\r\n  }\r\n  \r\n  body {\r\n    background: white;\r\n    color: black;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
